/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hoàng Văn Hoà",
  title: "Hi all, I'm Hoàng Văn Hoà",
  subTitle: emoji(
    "A highly committed Mechanical Design and Manufacturing Engineer with hands-on expertise in creating custom jigs, fixtures, and tools tailored for complex production environments. I specialize in sheet metal fabrication from conceptual design through prototyping to final production, and I'm proficient with industry-leading CAD/CAM platforms such as SolidWorks, Autodesk Inventor, Vault Pro, Fusion 360, HiCAD, CADMAN, and WICAM. I have practical experience in advanced robotic programming and simulation (RoboDK for FANUC), enabling precise automation and smooth integration into manufacturing workflows. I also implement and optimize ERP/PDM systems (Ridder IQ, Vault) to improve resource planning, production scheduling, and supply-chain coordination. Additionally, I create technical animations from Inventor and refine them in CapCut. I also work with Large Language Models (LLMs) — prompt engineering, evaluation, and deployment for applications and automation."
  ),
  resumeLink: "", // Set to empty to hide the button
  monthlyPaymentLink: "https://www.paypal.com/ncp/payment/SJ5DX2MBLA5UU",
  secondMonthlyPaymentLink: "https://www.paypal.com/ncp/payment/3PEQTAN6S7ƯTE",
  yearlyPaymentLink: "https://www.paypal.com/ncp/payment/6B9NMKE7PGPHN",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/imrtequila",
  linkedin: "https://www.linkedin.com/in/hoangvanhoackm",
  mail: "contact@hoangvanhoa.me",
  gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: "Some of the technologies I work with",
  skills: [
    emoji(
      "⚡ 3D mechanical design with SolidWorks, Autodesk Inventor and HiCAD"
    ),
    emoji(
      "⚡ CAM programming & robotic simulation using LVD CADMAN, RoboDK and WICAM"
    ),
    emoji(
      "⚡ Developing custom add-ins and automation for SolidWorks and Inventor"
    ),
    emoji(
      "⚡ Technical data management and ERP workflows using Autodesk Vault and Ridder IQ"
    ),
    emoji(
      "⚡ Creating animations from Autodesk Inventor and editing them in CapCut"
    )
    ,
    emoji(
      "⚡ Working with Large Language Models (LLMs) — prompt engineering, evaluation, and deployment (GPT, LLaMA, Claude, etc.)"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "SolidWorks",
      fontAwesomeClassname: "fas fa-cube"
    },
    {
      skillName: "Autodesk Inventor",
      fontAwesomeClassname: "fas fa-drafting-compass"
    },
    {
      skillName: "HiCAD",
      fontAwesomeClassname: "fas fa-cubes"
    },
    {
      skillName: "LVD CADMAN",
      fontAwesomeClassname: "fas fa-industry"
    },
    {
      skillName: "RoboDK",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "WICAM",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "SolidWorks API",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Inventor API",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Autodesk Vault",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Ridder IQ",
      fontAwesomeClassname: "fas fa-warehouse"
    },
    {
      skillName: "CapCut",
      fontAwesomeClassname: "fas fa-video"
    }
    ,
    {
      skillName: "Large Language Models (LLMs)",
      fontAwesomeClassname: "fas fa-robot"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Ho Chi Minh University of Technology and Education (HCMUTE)",
      logo: require("./assets/images/hcmute.png"),
      subHeader: "Bachelor — Mechanical Engineering (Manufacturing)",
      duration: "Class of 2005 - 2008; Graduated 2010",
      desc: "Specialized in mechanical manufacturing and machine design.",
      descBullets: [
        "Coursework and projects focused on sheet metal fabrication, jigs & fixtures, and machine design",
        "Practical lab and workshop experience in manufacturing processes"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "CAD (SolidWorks, Inventor, HiCAD)",
      progressPercentage: "80%"
    },
    {
      Stack: "CAM & Robotics (LVD CADMAN, RoboDK, WICAM)",
      progressPercentage: "70%"
    },
    {
      Stack: "Add-in Development (SolidWorks API, Inventor API)",
      progressPercentage: "60%"
    },
    {
      Stack: "PDM/PLM & ERP (Autodesk Vault, Ridder IQ)",
      progressPercentage: "50%"
    },
    {
      Stack: "Animation (Inventor to CapCut)",
      progressPercentage: "60%"
    }
    ,
    {
      Stack: "Large Language Models (LLMs)",
      progressPercentage: "65%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      website: "https://www.facebook.com",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Cabinanna",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      website: "https://www.cabin-anna.com/"
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Project Coordinator",
      company: "Dutch Partners",
      companylogo: require("./assets/images/nextuLogo.webp"),
      date: "Oct 2015 – Dec 2016",
      desc: "Collaborated with Dutch partners including Altrex, Numafa, Mr Fill, and Cabin Anna to coordinate projects and ensure quality and timely delivery."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    // Example video showcasing a product that I helped design and manufacture
    "https://www.youtube.com/embed/MC3NUYidxYE"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Contact Me 📞",
  subtitle:
    "Discuss a project or just want to say hi? My inbox is open for all.",
  number: "+84355065735",
  email_address: "contact@hoangvanhoa.me"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
